import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Typography, Divider, Button, Tag, Collapse, Comment, message, Spin, Space } from "antd";
// import SidebarLayout from './SidebarLayout';
import {
  CloseOutlined, CheckCircleOutlined, ClockCircleOutlined, ClockCircleTwoTone, LikeOutlined, RightOutlined, MessageOutlined, FileTextOutlined, ArrowRightOutlined,
  MailOutlined, LikeTwoTone, PhoneOutlined, UserOutlined, DashboardOutlined,FileDoneOutlined,SolutionOutlined, 
} from '@ant-design/icons'; // right!
import _BankerService from '../../modules/BankerService';
import { COMMON_ERROR_MSG } from '../../constants/constants';
import _commonService from '../../modules/commonService';
import StatusTag from '../../components/StatusTag';
import { useHistory, Link } from "react-router-dom";
import moment from "moment";
import { routes } from '../../routes/Routes';
import { PRIVATE_WEALTH_ADVISOR_ROLE, COMPLIANCE_ADMINISTRATOR_ROLE, UnderReviewStatusId } from '../../constants/DataConstants';
// import "./BankerDashboard.scss";
import SidebarLayout from '../BankerUI/SidebarLayout';
import "../BankerUI/BankerDashboard.scss";

const { Title, Paragraph, Text } = Typography;
const { Panel } = Collapse;

const ComplianceAdminDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [bankerMonthlySummaryData, setBankerMonthlySummaryData] = useState([]);
  const [unreviewedSummaryData, setUnreviewedSummary] = useState([]);
  const [clearedSummaryData, setClearedSummaryData] = useState([]);
  const [revisitSummaryData, setRevisitSummaryData] = useState([]);
  const [inprogressSummaryData, setInprogressSummaryData] = useState([]);

  const BankerFirstName = localStorage.getItem("BankerFirstName");
  const [bankerName] = useState(BankerFirstName);
  const isPrivateWealthAdvisor = localStorage.getItem("userRole") === PRIVATE_WEALTH_ADVISOR_ROLE;
  const isComplianceAdministrator = localStorage.getItem("userRole") === COMPLIANCE_ADMINISTRATOR_ROLE;

  const history = useHistory();
  const bankerIdRaw = localStorage.getItem("BankerId");
  const bankerId = bankerIdRaw ? parseInt(bankerIdRaw) : null;
  useEffect(() => {
    // if (!bankerId) {
    //   return;
    // }

    getBankerDataById();
  }, [bankerId, isComplianceAdministrator]);

  const getBankerDataById = async () => {
    try {
      setLoading(true);

      const res = await _BankerService.getComplianceDashboardSummaryByComplianceId(bankerId);

      if (res.data.IsSuccess) {
        setLoading(false);
        // setBankerMonthlySummaryData(res?.data?.Obj.monthlySummary);
        // setUnreviewedSummary(res?.data?.Obj.uploadDocumentApplications);
        // setRevisitSummaryData(res?.data?.Obj.SubmittedApplications);
        setBankerMonthlySummaryData(res?.data?.Obj.monthlySummary);
        setUnreviewedSummary(res?.data?.Obj.unreviewedSummary);
        setInprogressSummaryData(res?.data?.Obj.inprogressSummary);        //inprogressSummary
        setClearedSummaryData(res?.data?.Obj.clearedSummary); 
        setRevisitSummaryData(res?.data?.Obj.revisitSummary);
      } else {
        setLoading(false);
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const currentMonthYear = _commonService.getCurrentMonthAndYear();
  console.log("currentMonthYear", currentMonthYear);

  const handleClickUpdateApplicantStatus = async (item) => {
    if (isPrivateWealthAdvisor) {
      history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
      return;
    }

    if (item && item.Application_Status_Id && (item.Application_Status_Id != 4 && item.Application_Status_Id != 5 && item.Application_Status_Id != 8 && item.Application_Status_Id != 9 && item.Application_Status_Id != 7)) {
      let reqObj = {
        Id: item.Id,
        ApplicationId: item.ApplicationId,
        Application_Status_Id: UnderReviewStatusId,
        BankerId: bankerId,
        LoanOfficerId: null
      }
      setLoading(true);
      try {
        // const res = await _BankerService.updateApplicantStatus(reqObj);
        // if (res.data.IsSuccess) {
        //   setLoading(false);
        //   //message.success(res.data.Message);
        //   history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
        // } else {
        //   setLoading(false);
        //   message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
        // }

         history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
      } catch (err) {
        setLoading(false);
        console.log(err);
      }
      finally {
        setLoading(false);
      }
    } else {
      history.push({ pathname: "/loanApplicationDetails", state: { applicationData: item } });
    }
  }

  const onAllApplicationsClick = (flag) => {
    history.push({
      pathname: routes.loanApplicationsForComplianceAdmin.path,
      state: { applicationStatusFlag: flag }
    })
  }

  return (
    <Spin spinning={loading}>
      <SidebarLayout>
        <Row gutter={[32, 32]} justify="start" className='bank-dashboard-parent-div' >

          <Col xs={24} sm={24} md={24}>
            <Title level={3} className='page-title'>Hello, {bankerName}!</Title>
            <Title level={5} className='page-sub-title'>Monthly Summary, {currentMonthYear}</Title>
          </Col>

          <Col xs={24} sm={24} md={24} >
            <Row gutter={[24, 24]}>
              <Col xs={24} sm={12} md={12} lg={6}>
                <Card className='banker-dashboard-card card-section'>
                  <div className='banker-dashboard-card-title-row'>
                    <Text className='title-icon'>Unreviewed</Text>
                    <div className='cp-iconWrapStyle'>
                      <FileDoneOutlined/>
                    </div>
                  </div>
                  <div className='banker-dashboard-card-desc'>
                    <Title level={3} className='Card-Value'>
                      {unreviewedSummaryData && unreviewedSummaryData.UnreviewedApplicationCount}
                    </Title>
                    <Text className='card-footer-label'>Require Review</Text>
                  </div>
                </Card>
              </Col>

              <Col xs={24} sm={12} md={12} lg={6}>
                <Card className='banker-dashboard-card card-section'>
                  <div className='banker-dashboard-card-title-row'>
                    <Text className='title-icon'>In-Progress</Text>
                    <div className='cp-iconWrapStyle'>
                      <ClockCircleTwoTone/>
                    </div>
                  </div>
                  <div className='banker-dashboard-card-desc'>
                    <Title level={3} className='Card-Value'>
                    {inprogressSummaryData && inprogressSummaryData.InprogressApplicationCount}
                    </Title>
                    <Text className='card-footer-label'>Under Assessment</Text>
                  </div>
                </Card>
              </Col>



              {/* <Col xs={24} sm={12} md={6}>
                <Card className='cardStyle' bodyStyle={{ minHeight: 100 }}>
                  <div className='iconWrapStyle'>
                    <ClockCircleTwoTone twoToneColor="#3570EC" />
                  </div>
                  <Text>In-Progress</Text>
                  <br />
                  <Title level={3} style={{ margin: "12px 0 0 0", fontWeight: 600, color: "#222" }}>
                    {inprogressSummaryData && inprogressSummaryData.InprogressApplicationCount}
                  </Title>
                  <Divider style={{ margin: "12px 0" }} />
              <span style={{ color: "#8A94A6", fontSize: 15 }}>
                Last Month: <span style={{ color: "#222", fontWeight: 500 }}>{bankerMonthlySummaryData && bankerMonthlySummaryData.InProgressApplicationLastMonth}</span>
              </span>
                </Card>
              </Col> */}

              <Col xs={24} sm={12} md={12} lg={6}>
                <Card className='banker-dashboard-card card-section'>
                  <div className='banker-dashboard-card-title-row'>
                    <Text className='title-icon'>Cleared</Text>
                    <div className='cp-iconWrapStyle'>
                      <CheckCircleOutlined />

                    </div>
                  </div>
                  <div className='banker-dashboard-card-desc'>
                    <Title level={3} className='Card-Value'>
                      {clearedSummaryData && clearedSummaryData.ClearedApplicationCount}
                    </Title>
                    <Text className='card-footer-label'>Application Cleared</Text>
                  </div>
                </Card>
              </Col>

              <Col xs={24} sm={12} md={12} lg={6}>
                <Card className='banker-dashboard-card card-section'>
                  <div className='banker-dashboard-card-title-row'>
                    <Text className='title-icon'>Revisit</Text>
                    <div className='cp-iconWrapStyle'>
                      <SolutionOutlined/>

                    </div>
                  </div>
                  <div className='banker-dashboard-card-desc'>
                    <Title level={3} className='Card-Value'>
                      {revisitSummaryData && revisitSummaryData.RevisitApplicationCount}
                    </Title>
                    <Text className='card-footer-label'>Approved / Rejected</Text>
                  </div>
                </Card>
              </Col>

              {/* 
              <Col xs={24} sm={12} md={12} lg={6}>
                <Card className='cardStyle' bodyStyle={{ minHeight: 100 }}>
                  <div className='iconWrapStyle'>
                    <LikeTwoTone twoToneColor="#3570EC" />
                  </div>
                  <Text>Recommended</Text>
                  <br />
                  <Title level={3} style={{ margin: "12px 0 0 0", fontWeight: 600, color: "#222" }}>
                    {bankerMonthlySummaryData && bankerMonthlySummaryData.RecommendedApplication}
                  </Title>
                  <Divider style={{ margin: "12px 0" }} />
              <span style={{ color: "#8A94A6", fontSize: 15 }}>
                Last Month: <span style={{ color: "#222", fontWeight: 500 }}>{bankerMonthlySummaryData && bankerMonthlySummaryData.LoanApprovedLastMonth}</span>
              </span>
                </Card>
              </Col> */}


              {/* <Col xs={24} sm={12} md={12} lg={6}>
                <Card className='banker-dashboard-card card-section'>
                  <div className='banker-dashboard-card-title-row'>
                    <Text className='title-icon'>Recommended</Text>
                    <div className='cp-iconWrapStyle'>
                      <LikeOutlined />

                    </div>
                  </div>
                  <div className='banker-dashboard-card-desc'>
                    <Title level={3} className='Card-Value'>
                      {bankerMonthlySummaryData && bankerMonthlySummaryData.RecommendedApplication}
                    </Title>
                    <Text className='card-footer-label'>Ready For Approval</Text>
                  </div>
                </Card>
              </Col> */}

              {/* <Col xs={24} sm={12} md={12} lg={6}>
                <Card className='cardStyle' bodyStyle={{ minHeight: 100 }}>
                  <div className='iconWrapStyle'>
                    <CheckCircleTwoTone twoToneColor="#3570EC" />
                  </div>
                  <Text>Approved</Text>
                  <br />
                  <Title level={3} style={{ margin: "12px 0 0 0", fontWeight: 600, color: "#222" }}>
                    {bankerMonthlySummaryData && bankerMonthlySummaryData.LoanApproved}
                  </Title>
                  <Divider style={{ margin: "12px 0" }} />
              <span style={{ color: "#8A94A6", fontSize: 15 }}>
                Last Month: <span style={{ color: "#222", fontWeight: 500 }}>{bankerMonthlySummaryData && bankerMonthlySummaryData.LoanApprovedLastMonth}</span>
              </span>
                </Card>
              </Col> */}

              {/* <Col xs={24} sm={12} md={12} lg={8}>
                <Card className='banker-dashboard-card card-section'>
                  <div className='banker-dashboard-card-title-row'>
                    <Text className='title-icon'>Approved</Text>
                    <div className='cp-iconWrapStyle'>
                      <CheckCircleOutlined />

                    </div>
                  </div>
                  <div className='banker-dashboard-card-desc'>
                    <Title level={3} className='Card-Value'>
                      {bankerMonthlySummaryData && bankerMonthlySummaryData.LoanApproved}
                    </Title>
                    <Text className='card-footer-label'>Completed</Text>
                  </div>
                </Card>
              </Col> */}

            </Row>
          </Col>
          {/* </Row>

        <Row gutter={[24, 24]}> */}
          {/* <Col xs={24} sm={24} md={24}>
            <Title level={5} className='app-title'>Unreviewed Applications:  {unreviewedSummaryData.UploadDocumentApplicationCount}</Title>
          </Col> */}
          {/* </Row> */}

          <Col xs={24} sm={24} md={24} >
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={24}>
                <Title level={5} className='app-title'>Unreviewed Applications:  {unreviewedSummaryData.UnreviewedApplicationCount}</Title>
              </Col>
              {unreviewedSummaryData?.listApplicantBankerDashbordUnreviewedModel?.map((unreviewedSummary) => (
                <Col xs={24} sm={24} md={24}>
                  <Card className='banker-dashboard-card-section card-section' key={unreviewedSummary.Id}>
                    {/* <Collapse
                      accordion
                      expandIconPosition="end"
                      ghost

                    >
                      <Panel
                        showArrow={false}
                        header={
                          <div> */}
                    <div>
                      <div> <StatusTag statusId={unreviewedSummary.Application_Status_Id} /></div>
                      <Row gutter={[16, 12]} align="middle" className="app-info-row">
                        <Col>
                          <div className="app-icon">
                            <FileTextOutlined />
                          </div>
                        </Col>
                        <Col flex="auto">
                          <Row justify="end" align="middle">
                            {/* <Col>
                              <StatusTag statusId={unreviewedSummary.Application_Status_Id} />
                            </Col> */}

                            <Col>
                              <Button
                                type="link"
                                className="viewAppBtn"
                                onClick={() =>
                                  handleClickUpdateApplicantStatus(unreviewedSummary)
                                }
                              >
                                View Application <ArrowRightOutlined />
                              </Button>
                            </Col>
                          </Row>
                          <Row className="app-info">
                            <Col xs={24} sm={24} md={24}>
                              <Text className='app-info-label'>Application : </Text>
                              <span className="app-info-value">
                                {unreviewedSummary.ApplicationId}
                              </span>
                            </Col>
                          </Row>

                          <Row className="app-info">
                            <Col xs={24} sm={24} md={24}>
                              <Text className='app-info-label'>Applicant : </Text>
                              <span className="app-info-value">
                                {unreviewedSummary.ApplicantName}
                              </span>
                            </Col>
                          </Row>

                          <Row className="app-info">
                            <Col xs={24} sm={24} md={24}>
                              <Text className='app-info-label'>Loan Amount : </Text>

                              <span className="app-info-value">
                                $
                                {_commonService.formatNumberWithCommas(
                                  unreviewedSummary.ApplicantLoanAmount
                                )}
                              </span>
                            </Col>
                          </Row>

                          <Row className="app-info">
                            <Col xs={24} sm={24} md={24}>
                              <Text className='app-info-label'>Firm Name : </Text>

                              <span className="app-info-value">
                                
                                {_commonService.formatNumberWithCommas(
                                  unreviewedSummary.SponserCompany
                                )}
                              </span>
                            </Col>
                          </Row>

                          <Row className="app-info">
                            <Col xs={24} sm={24} md={24}>
                              <Text className='app-info-label'>Date & Time : </Text>

                              <span className="app-info-value">
                                {unreviewedSummary?.CreatedDate
                                  ? _commonService.formatDateTimeAMPM(
                                    unreviewedSummary.CreatedDate
                                  )
                                  : "N/A"}
                              </span>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </div>

                    {/* <Row>


                              <Col xs={24} sm={24} md={24}>
                                <FileTextOutlined style={{ fontSize: 50, color: "#8c8c8c" }} />

                                <Space split={<Divider type="vertical" />}>
                                  <label><Text strong>Application:</Text> {unreviewedSummary.ApplicationId}</label>
                                  <label><Text strong>Applicant :</Text> {unreviewedSummary.ApplicantName}</label>
                                  <label><Text strong>Loan Amount:</Text> $ {_commonService.formatNumberWithCommas(unreviewedSummary.ApplicantLoanAmount)}</label>
                                </Space>

                              </Col>
                            </Row> */}
                    {/* </div>
                        }
                      >
                      </Panel>
                    </Collapse> */}

                    {/* <Divider className='mb10 mt10' /> */}

                    {/* <Row> */}
                    {/* <Col xs={12} sm={12} md={12}>
                        <label>
                          <Text strong>Date & Time:</Text> {unreviewedSummary?.CreatedDate ? _commonService.formatDateTimeAMPM(unreviewedSummary.CreatedDate) : "N/A"}
                        </label>
                      </Col> */}

                    {/* </Row> */}
                  </Card>
                </Col>
              ))}
              {unreviewedSummaryData && unreviewedSummaryData.UnreviewedApplicationCount > 0 ?
                <Col xs={24} sm={24} md={24}>
                  <Button
                    type="link"
                    className="fRight viewAppBtn"
                    onClick={() => onAllApplicationsClick(2)}
                  >
                     View All Unreviewed Applications <ArrowRightOutlined />
                  </Button>
                </Col> :

                <Col xs={24} sm={24} md={24}>
                  <div className='card-section' style={{ textAlign: "center" }}>
                    <text className='no-application-found'>No Applications Found.</text>
                  </div>
                </Col>
              }
            </Row>
          </Col>


         <Col xs={24} sm={24} md={24}>

            <Row gutter={[16, 16]}>
              {/* <Row gutter={[24, 24]} className='mb10'> */}
              <Col xs={24} sm={24} md={24}>
                <Title level={5} className='app-title'>In Progress Applications: {inprogressSummaryData.InprogressApplicationCount}</Title>
              </Col>
              {/* </Row> */}
              {
                inprogressSummaryData?.listApplicantBankerDashbordInprogressApplicationModel?.map((inprogressSummary) => {

                  // const latestloanOfficerName = revisitSummary.listApplicationReviewCommentModels &&
                  //   revisitSummary.listApplicationReviewCommentModels
                  //     .filter(item => item.ReviewCommentsBy_LoanOfficerId > 0)
                  //     .sort((a, b) => new Date(b.ReviewCommentDate) - new Date(a.ReviewCommentDate))[0];

                  return (
                    <Col xs={24} sm={24} md={24} key={inprogressSummary.Id}>
                      <Card className="banker-dashboard-card-section card-section">
                        <Collapse
                          accordion
                          expandIconPosition="end"
                          ghost
                          expandIcon={({ isActive }) => (
                            <div
                              style={{
                                width: 24,
                                height: 24,
                                borderRadius: "50%",
                                backgroundColor: "#414957",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "transform 0.3s",
                                transform: isActive ? "rotate(-90deg)" : "rotate(90deg)",
                              }}
                            >
                              <RightOutlined style={{ color: "white", fontSize: 12 }} />
                            </div>
                          )}
                        >
                          <Panel
                            // collapsible="icon"
                            // header={
                            //   <Row justify="space-between" align="middle" style={{ width: "100%" }}>
                            //     <Col xs={24} sm={24} md={24} className="left-balance mb10">
                            //       <StatusTag statusId={revisitSummary.Application_Status_Id} />
                            //     </Col>
                            //     <Col xs={24} sm={24} md={24} className="right-balance">
                            //       <FileTextOutlined style={{ fontSize: 50, color: "#8c8c8c" }} />
                            //       <Space split={<Divider type="vertical" />}>
                            //         <label className='ml20'><Text strong>Application:</Text> {revisitSummary.ApplicationId}</label>
                            //         <label><Text strong>Applicant :</Text> {revisitSummary.ApplicantName}</label>
                            //         <label><Text strong>Loan Amount:</Text> $ {_commonService.formatNumberWithCommas(revisitSummary.ApplicantLoanAmount)}</label>
                            //       </Space>
                            //     </Col>
                            //   </Row>
                            // }

                            header={
                              <div>
                                <div><StatusTag statusId={inprogressSummary.Application_Status_Id} /></div>
                                <Row gutter={[16, 12]} align="middle" className="app-info-row">
                                  <Col>
                                    <div className="app-icon">
                                      <FileTextOutlined />
                                    </div>
                                  </Col>
                                  <Col flex="auto">
                                    <Row justify="end" align="middle">
                                      {/* <Col>
                                        <StatusTag statusId={revisitSummary.Application_Status_Id} />
                                      </Col> */}

                                      <Col>
                                        <Button
                                          type="link"
                                          className="viewAppBtn"
                                          onClick={() =>
                                            handleClickUpdateApplicantStatus(inprogressSummary)
                                          }
                                        >
                                          View Application <ArrowRightOutlined />
                                        </Button>
                                      </Col>
                                    </Row>
                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className="app-info-label">Application :</Text>
                                        <span className="app-info-value">
                                          {inprogressSummary.ApplicationId}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className="app-info-label">Client :</Text>
                                        <span className="app-info-value">
                                          {inprogressSummary.ApplicantName}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className="app-info-label">Loan Amount :</Text>

                                        <span className="app-info-value">
                                          $
                                          {_commonService.formatNumberWithCommas(
                                            inprogressSummary.ApplicantLoanAmount
                                          )}
                                        </span>
                                      </Col>
                                    </Row>


                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className='app-info-label'>Firm Name : </Text>

                                        <span className="app-info-value">
                                          
                                          {_commonService.formatNumberWithCommas(
                                            inprogressSummary.SponserCompany
                                          )}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className="app-info-label">Date & Time :</Text>

                                        <span className="app-info-value">
                                          {inprogressSummary?.CreatedDate
                                            ? _commonService.formatDateTimeAMPM(
                                              inprogressSummary.CreatedDate
                                            )
                                            : "N/A"}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </div>
                            }
                          >
                            <Row gutter={[16, 16]} justify="space-between" className='comment-section-parent-div card-section'>


                              {
                                inprogressSummary.listApplicationReviewCommentModels.map((comment, index) =>
                                  // (comment.Remarks || comment.Comments) && (
                                  <Col
                                    xs={24} sm={24} md={24}>
                                    <Comment
                                      key={index}
                                      className='revisitComment'
                                      avatar={
                                        <MessageOutlined />
                                      }


                                      content={
                                        // <>

                                        //   {/* {comment.Remarks && ( */}
                                        //   {/* <p className='mb10'><strong>Remarks:</strong> {comment.Remarks || "N/A"}</p> */}
                                        //   {/* )} */}
                                        //   {/* {comment.Comments && ( */}
                                        //   <p className='mb10'><strong>Comments:</strong> {comment.Comments || "N/A"}</p>

                                        //   <p className='mb10'><strong>Date & Time:</strong> {comment.ReviewCommentDate ? _commonService.formatDateTimeAMPM(comment.ReviewCommentDate) : "N/A"}</p>
                                        //   {/* )} */}



                                        // </>

                                        <div className='mt8'>
                                          <p className="">
                                            <strong className="app-info-label">Comments :</strong>
                                            <span className="app-info-value">
                                              {comment.Comments || "N/A"}
                                            </span>
                                          </p>

                                          <p className="">
                                            <strong className="app-info-label">Date & Time :</strong>
                                            <span className="app-info-value">
                                              {comment.ReviewCommentDate
                                                ? _commonService.formatDateTimeAMPM(comment.ReviewCommentDate)
                                                : "N/A"}
                                            </span>
                                          </p>
                                        </div>



                                      }
                                    />


                                  </Col>
                                  // )
                                )
                              }

                            </Row>
                          </Panel>
                        </Collapse>
                        {/* <Divider className='mb10 mt10'></Divider> */}
                        {/* <Row>
                      <Col xs={12} sm={12} md={12}>
                        <div>
                          <label className='ml20'><Text strong>Date & Time:</Text> {revisitSummary?.CreatedDate ? _commonService.formatDateTimeAMPM(revisitSummary.CreatedDate) : "N/A"}
                          </label>
                        </div>
                      </Col>
                      <Col xs={12} sm={12} md={12}>
                        <Button
                          type="link"
                          className="fRight viewBtn"

                          onClick={() => { handleClickUpdateApplicantStatus(revisitSummary) }}
                        >
                          View Application <ArrowRightOutlined />
                        </Button>
                      </Col>
                    </Row> */}
                      </Card>
                    </Col>
                  )
                })
              }


              {inprogressSummaryData && inprogressSummaryData.InprogressApplicationCount > 0 ?
                <Col xs={24} sm={24} md={24}>
                  <Button
                    type="link"
                    className="fRight viewAppBtn"
                    // onClick={() => history.push(routes.revisionrequest.path)}
                    onClick={() => onAllApplicationsClick(3)}
                  >
                     View All In-Progress Applications <ArrowRightOutlined />
                  </Button>
                </Col> :

                <Col xs={24} sm={24} md={24}>
                  <div className='card-section' style={{ textAlign: "center" }}>
                    <text className='no-application-found'>No Applications Found.</text>
                  </div>
                </Col>
              }
            </Row>
          </Col>

           <Col xs={24} sm={24} md={24}>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={24}>
                <Title level={5} className='app-title'>Cleared Applications: {clearedSummaryData.ClearedApplicationCount}</Title>
              </Col>
              {
                clearedSummaryData?.listApplicantBankerDashbordClearedModel?.map((clearedSummary) => {
                  return (
                    <Col xs={24} sm={24} md={24} key={clearedSummary.Id}>
                      <Card className="banker-dashboard-card-section card-section">
                        <Collapse
                          accordion
                          expandIconPosition="end"
                          ghost
                          expandIcon={({ isActive }) => (
                            <div
                              style={{
                                width: 24,
                                height: 24,
                                borderRadius: "50%",
                                backgroundColor: "#414957",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "transform 0.3s",
                                transform: isActive ? "rotate(-90deg)" : "rotate(90deg)",
                              }}
                            >
                              <RightOutlined style={{ color: "white", fontSize: 12 }} />
                            </div>
                          )}
                        >
                          <Panel
                            header={
                              <div>
                                <div><StatusTag statusId={clearedSummary.Application_Status_Id} /></div>
                                <Row gutter={[16, 12]} align="middle" className="app-info-row">
                                  <Col>
                                    <div className="app-icon">
                                      <FileTextOutlined />
                                    </div>
                                  </Col>
                                  <Col flex="auto">
                                    <Row justify="end" align="middle">
                                      <Col>
                                        <Button
                                          type="link"
                                          className="viewAppBtn"
                                          onClick={() =>
                                            handleClickUpdateApplicantStatus(clearedSummary)
                                          }
                                        >
                                          View Application <ArrowRightOutlined />
                                        </Button>
                                      </Col>
                                    </Row>
                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className="app-info-label">Application :</Text>
                                        <span className="app-info-value">
                                           {clearedSummary.ApplicationId}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className="app-info-label">Client :</Text>
                                        <span className="app-info-value">
                                          {clearedSummary.ApplicantName}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className="app-info-label">Loan Amount :</Text>

                                        <span className="app-info-value">
                                          $
                                          {_commonService.formatNumberWithCommas(
                                            clearedSummary.ApplicantLoanAmount
                                          )}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className='app-info-label'>Firm Name : </Text>

                                        <span className="app-info-value">
                                          {_commonService.formatNumberWithCommas(
                                            clearedSummary.SponserCompany
                                          )}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className="app-info-label">Date & Time :</Text>

                                        <span className="app-info-value">
                                          {clearedSummary?.CreatedDate
                                            ? _commonService.formatDateTimeAMPM(
                                              clearedSummary.CreatedDate
                                            )
                                            : "N/A"}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </div>
                            }
                          >
                            <Row gutter={[16, 16]} justify="space-between" className='comment-section-parent-div card-section'>
                              {
                                clearedSummary.listApplicationReviewCommentModels?.map((comment, index) =>
                                  <Col xs={24} sm={24} md={24} key={index}>
                                    <Comment
                                      className='revisitComment'
                                      avatar={
                                        <MessageOutlined />
                                      }
                                      content={
                                        <div className='mt8'>
                                          <p className="">
                                            <strong className="app-info-label">Comments :</strong>
                                            <span className="app-info-value">
                                              {comment.Comments || "N/A"}
                                            </span>
                                          </p>

                                          <p className="">
                                            <strong className="app-info-label">Date & Time :</strong>
                                            <span className="app-info-value">
                                              {comment.ReviewCommentDate
                                                ? _commonService.formatDateTimeAMPM(comment.ReviewCommentDate)
                                                : "N/A"}
                                            </span>
                                          </p>
                                        </div>
                                      }
                                    />
                                  </Col>
                                )
                              }
                            </Row>
                          </Panel>
                        </Collapse>
                      </Card>
                    </Col>
                  )
                })
              }

              {clearedSummaryData && clearedSummaryData.ClearedApplicationCount > 0 ?
                <Col xs={24} sm={24} md={24}>
                  <Button
                    type="link"
                    className="fRight viewAppBtn"
                    onClick={() => onAllApplicationsClick(6)}
                  >
                    View All Cleared Applications <ArrowRightOutlined />
                  </Button>
                </Col> :

                <Col xs={24} sm={24} md={24}>
                  <div className='card-section' style={{ textAlign: "center" }}>
                    <text className='no-application-found'>No Applications Found.</text>
                  </div>
                </Col>
              }
            </Row>
          </Col>

          <Col xs={24} sm={24} md={24}>
            <Row gutter={[16, 16]}>
              <Col xs={24} sm={24} md={24}>
                <Title level={5} className='app-title'>Revisit Applications: {revisitSummaryData.RevisitApplicationCount}</Title>
              </Col>
              {
                revisitSummaryData?.listApplicantBankerDashbordRevisitApplicationModel?.map((revisitSummary) => {
                  return (
                    <Col xs={24} sm={24} md={24} key={revisitSummary.Id}>
                      <Card className="banker-dashboard-card-section card-section">
                        <Collapse
                          accordion
                          expandIconPosition="end"
                          ghost
                          expandIcon={({ isActive }) => (
                            <div
                              style={{
                                width: 24,
                                height: 24,
                                borderRadius: "50%",
                                backgroundColor: "#414957",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                transition: "transform 0.3s",
                                transform: isActive ? "rotate(-90deg)" : "rotate(90deg)",
                              }}
                            >
                              <RightOutlined style={{ color: "white", fontSize: 12 }} />
                            </div>
                          )}
                        >
                          <Panel
                            header={
                              <div>
                                <div><StatusTag statusId={revisitSummary.Application_Status_Id} /></div>
                                <Row gutter={[16, 12]} align="middle" className="app-info-row">
                                  <Col>
                                    <div className="app-icon">
                                      <FileTextOutlined />
                                    </div>
                                  </Col>
                                  <Col flex="auto">
                                    <Row justify="end" align="middle">
                                      <Col>
                                        <Button
                                          type="link"
                                          className="viewAppBtn"
                                          onClick={() =>
                                            handleClickUpdateApplicantStatus(revisitSummary)
                                          }
                                        >
                                          View Application <ArrowRightOutlined />
                                        </Button>
                                      </Col>
                                    </Row>
                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className="app-info-label">Application :</Text>
                                        <span className="app-info-value">
                                          {revisitSummary.ApplicationId}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className="app-info-label">Client :</Text>
                                        <span className="app-info-value">
                                          {revisitSummary.ApplicantName}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className="app-info-label">Loan Amount :</Text>

                                        <span className="app-info-value">
                                          $
                                          {_commonService.formatNumberWithCommas(
                                            revisitSummary.ApplicantLoanAmount
                                          )}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className='app-info-label'>Firm Name : </Text>

                                        <span className="app-info-value">
                                          {_commonService.formatNumberWithCommas(
                                            revisitSummary.SponserCompany
                                          )}
                                        </span>
                                      </Col>
                                    </Row>

                                    <Row className="app-info">
                                      <Col xs={24} sm={24} md={24}>
                                        <Text className="app-info-label">Date & Time :</Text>

                                        <span className="app-info-value">
                                          {revisitSummary?.CreatedDate
                                            ? _commonService.formatDateTimeAMPM(
                                              revisitSummary.CreatedDate
                                            )
                                            : "N/A"}
                                        </span>
                                      </Col>
                                    </Row>
                                  </Col>
                                </Row>
                              </div>
                            }
                          >
                            <Row gutter={[16, 16]} justify="space-between" className='comment-section-parent-div card-section'>
                              {
                                revisitSummary.listApplicationReviewCommentModels?.map((comment, index) =>
                                  <Col xs={24} sm={24} md={24} key={index}>
                                    <Comment
                                      className='revisitComment'
                                      avatar={
                                        <MessageOutlined />
                                      }
                                      content={
                                        <div className='mt8'>
                                          <p className="">
                                            <strong className="app-info-label">Comments :</strong>
                                            <span className="app-info-value">
                                              {comment.Comments || "N/A"}
                                            </span>
                                          </p>

                                          <p className="">
                                            <strong className="app-info-label">Date & Time :</strong>
                                            <span className="app-info-value">
                                              {comment.ReviewCommentDate
                                                ? _commonService.formatDateTimeAMPM(comment.ReviewCommentDate)
                                                : "N/A"}
                                            </span>
                                          </p>
                                        </div>
                                      }
                                    />
                                  </Col>
                                )
                              }
                            </Row>
                          </Panel>
                        </Collapse>
                      </Card>
                    </Col>
                  )
                })
              }

              {revisitSummaryData && revisitSummaryData.RevisitApplicationCount > 0 ?
                <Col xs={24} sm={24} md={24}>
                  <Button
                    type="link"
                    className="fRight viewAppBtn"
                    onClick={() => onAllApplicationsClick(5)}
                  >
                    View All Revisit Applications <ArrowRightOutlined />
                  </Button>
                </Col> :

                <Col xs={24} sm={24} md={24}>
                  <div className='card-section' style={{ textAlign: "center" }}>
                    <text className='no-application-found'>No Applications Found.</text>
                  </div>
                </Col>
              }
            </Row>
          </Col>
        </Row>
      </SidebarLayout>
    </Spin>
  );
};

export default ComplianceAdminDashboard;
